/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnInit} from '@angular/core';
import * as _ from 'lodash';

import template from './ip-address-targeting.component.html';
import {ADN_TARGETING_TYPES} from '../targeting-constants';
import {TargetingTemplateHook} from './targeting-template.component';
import {IpAddress} from '../../../components/util/ip-valid';

import {TARGETING_IMPORTS} from '../targeting-imports';
import {TargetingTemplateComponent} from './targeting-template.component';

@Component({
  imports: [...TARGETING_IMPORTS, TargetingTemplateComponent],
  selector: 'adn-ip-address-targeting',
  template
})
export class IpAddressTargetingComponent implements OnInit {
  @Input() model: any;
  @Input() tabController: any;
  @Input() overridableTargeting: any;
  @Input() targetType: any = ADN_TARGETING_TYPES.ipAddress;
  @Input() underModel: any;
  @Input() mode: string;
  @Input() isLockedDown: boolean;
  @Input() mandatory: boolean;

  inputted = {value: ''};

  readonly templateHook: TargetingTemplateHook = {
    getTemplateData: () => {
      this.prepareForSave();
      const model = this.model || {};
      return {
        vm: _.cloneDeep(this.inputted),
        model: _.cloneDeep(model),
        constant: ADN_TARGETING_TYPES.ipAddress,
        summary: (model.negated === true ? 'NOT: ' : '') + (model.addresses || []).join(', ')
      };
    },
    copyTemplate: (tpl: any) => this.copyTemplate(tpl)
  };

  ngOnInit(): void {
    this.initFromModel();

    if (!this.tabController) {
      return;
    }

    const prepareForSave = () => this.prepareForSave();
    const copyTemplate = (tpl: any) => this.copyTemplate(tpl);
    this.tabController.register(ADN_TARGETING_TYPES.ipAddress.widget, prepareForSave, copyTemplate);
    this.tabController.callBeforeSubmit(prepareForSave);
    this.tabController.registerAllTabs(prepareForSave);
  }

  private initFromModel(): void {
    const addresses = _.get(this.model, 'addresses') || [];
    this.inputted = {value: addresses.join(', ')};
  }

  private prepareForSave(): void {
    if (!this.model) {
      return;
    }
    const values = (this.inputted.value || '').split(',');
    const trimmedValues = _.filter(_.map(values, (v) => _.trim(v)), (v) => {
      return _.isString(v) && v.length > 0 && IpAddress.isValid(v);
    });
    this.model.addresses = trimmedValues;
    this.initFromModel();
  }

  private copyTemplate(tpl: any): void {
    if (!this.model) {
      return;
    }
    const copied = _.cloneDeep(_.get(tpl, ['data', 'model'])) || {addresses: []};
    Object.keys(this.model).forEach((key) => delete this.model[key]);
    Object.assign(this.model, copied);
    this.initFromModel();
  }
}
